import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import TableIcon from "../assets/enter-table.svg";

const HostSeatRequest = () => {
  const { t } = useI18n(["template"]);

  return (
    <div className="hs-cnt">
      <img src={TableIcon} alt={t("template:someone.entering.table")} />
      <Typography variant="h3">
        {t("template:some.one.trying.access.table")}
      </Typography>
      <Typography variant="body1">{t("template:move.admin.seat")}</Typography>
    </div>
  );
};

export default HostSeatRequest;
